<div class=" bg-body-tertiary" id="giveMore">
  <div class="container py-5 text-center">
    <span class="fs-2 fw-bold">¿Cómo solicitar <span class="fw-medium">el servicio?</span></span>
  </div>

  <!-- Three columns of text below the carousel -->
  <div class="row d-flex mx-auto   w-75">
    <div class="col-lg-4">
      <div class="card mx-auto my-3" style="width: 15rem; height: 15rem">
        <div class="card-body text-center mt-1">
          <img ngSrc="assets/img/movilink/whatsapLogo.svg"  style="margin-bottom: 7px" alt="whatsapLogo" class="flex-shrink-0" height="40"
               width="40">
          <div class="container mt-3 pb-3 lh-sm">
            <p class="card-text fw-bold fs-5 lh-sm">Contáctate <br>
              <span class="fw-medium fs-6 text-secondary"> con nosotros</span>
            </p>
          </div>
          <div class="container mt-3">

            <a href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" target="_blank" style="background-color: var(--yellow-medilink)" class=" card-link text-light">Agendar el servicio</a>
          </div>

        </div>
      </div>
    </div><!-- /.col-lg-4 -->
    <div class="col-lg-4">
      <div class="card mx-auto my-3" style="width: 15rem; height: 15rem">
        <div class="card-body text-center mt-1">
          <img ngSrc="assets/img/movilink/pago.svg" alt="pago" class=" flex-shrink-0" height="50"
               width="50">
          <div class="container mt-3 lh-sm">
            <p class="card-text fw-bold fs-5">Realiza tu pago <br>
              <span class="fw-medium fs-6 text-secondary">tarjeta de crédito, débito o transferencia.</span>
            </p>
          </div>


        </div>
      </div>
    </div><!-- /.col-lg-4 -->
    <div class="col-lg-4">
      <div class="card mx-auto my-3" style="width: 15rem; height: 15rem">
        <div class="card-body  text-center mt-1">
          <img ngSrc="assets/img/movilink/serviceMedic.svg" alt="serviceMedic" class=" flex-shrink-0" height="50"
               width="50">
          <div class="container mt-3 lh-sm">
            <p class="card-text fw-bold fs-5">Recibe el  <br>
              <span class="fw-medium fs-6 text-secondary"> servicio médico</span>
            </p>
          </div>


        </div>
      </div>
    </div><!-- /.col-lg-4 -->
  </div>


  <div class="container py-5 ">
    <div class="container text-center">
      <p class="fw-bold fs-5 pt-2" style="color: var(--secondary-color)">Si presentas algún síntoma, agenda al:</p>
    </div>

    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center">
      <button class="buttonAction d-flex align-items-center justify-content-center">
          <img ngSrc="assets/img/movilink/llamadaIcon.svg" alt="llamadaLogo" class=" flex-shrink-0" height="30" width="30">
          <span class="text-light px-2 fs-1">5 50 50 52</span>
        </button>
        <a target="_blank" href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" class="buttonAction d-flex align-items-center justify-content-center">
          <img ngSrc="assets/img/movilink/whatsapLogo.svg" alt="whatsapLogo" class=" flex-shrink-0" height="30" width="30">
          <span class="text-light px-2 fs-1">099 318 3975</span>
        </a>
    </div>
  </div>

 <!-- <div class="container text-center">

    <svg viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg"
         width="35" height="35" fill="none">
      <style>@keyframes slide-2{to{transform:translateY(2px)}}
      </style><path fill="#274485FF" fill-rule="evenodd" d="M17.358 12.632a.714.714 0 01-.092 1.006l-4.276 3.564a.712.712 0 01-.933 0L7.78 13.638a.714.714 0 11.915-1.097l3.078 2.565V7.375a.75.75 0 011.5 0v7.73l3.079-2.564a.714.714 0 011.006.091z" clip-rule="evenodd" style="animation:slide-2 1s infinite alternate both cubic-bezier(1,-.01,0,.98)"/>
    </svg>
  </div>-->

</div>


